<script>
export default {
  name: 'TheHero',
  mounted() {
    if (this.$refs.wysiwyg) {
      this.$refs.wysiwyg.querySelectorAll('a').forEach((el) => {
        el.addEventListener('focus', () => { this.tryScrollInView(); });
      });
    }
  },
  methods: {
    tryScrollInView() {
      if (document.documentElement.classList.contains('pointer-user') || this.isMobile()) return;
      window.scrollTo({
        behavior: 'smooth',
        top: 0,
      });
    },
    isMobile() {
      return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < 768;
    },
  },
};
</script>
